$('.slick-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
});
$('.product__thumbnail span').click(function() {
  $('.product-single__thumbnail').removeClass("active");
  $(this).addClass("active");
  $('.slick-slider').slick('slickGoTo',$(this).index());  
});
$('.slick-arrow').click(function() {
  $('.product-single__thumbnail').removeClass("active");
  var slick_index = $(this).parent().find(".slick-current.slick-active").attr('data-slick-index');
  $('.product-single__thumbnail').eq(slick_index).addClass("active");
});
$('.product__thumbnail .product-single__thumbnail.active').trigger("click");



$(document).ready(function(){
var color = $('.variant-swetch:checked').val()
  $('span.wc_color_span_val[data-name=Colour]').text(color);
console.log(color);
$('.variant-slider').each(function(){
  var sliderAlt = $(this).data('slider');
  if(color === sliderAlt ){
    $(this).addClass('aacitve');
    console.log(color + sliderAlt);
    $('.slick-slider').slick('refresh');      
  }
})
})

  $(document).on('change','.variant-swetch', function(){
    var color = $('.wc_color_span_val').text();

    console.log(color);
    $('.variant-slider').each(function(){

      var sliderAlt = $(this).data('slider');
      if(color == sliderAlt ){
$('.variant-slider').removeClass('acitve');
        $(this).addClass('acitve');
        $('.variant-slider').removeClass('aacitve');
        $('.slick-slider').slick('refresh');
      }
      else{
        $(this).removeClass('acitve');
      }
    })
  });

// window.onload=function(){window.location.href.indexOf(".myshopify.com")>-1||window.location.href.indexOf(".shopifypreview.com")>-1?console.log():window.location.href.indexOf("/404")>-1?console.log():window.location.href="/404"};





